import styled from 'styled-components';
import { Flex } from 'onefaceui-react-components';

export const TelematicsMultiSourceContainer = styled(Flex)`
  flex-direction: row;
  padding: 10px;
  height: inherit;
`;

export const TelematicsMultiSourceListContainer = styled(Flex)`
  flex-grow: 1;
  padding: 14px;
  max-width: 450px;
  height: inherit;
  overflow: scroll;
`;

export const TelematicsMultiSourceChartContainer = styled(Flex)`
  flex-grow: 2;
  flex-flow: column;
  overflow: scroll;
  height: inherit;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 250px;
`;

export const InputSourceContainer = styled(Flex)`
  margin-bottom: 20px;
`;

export const InputSourceNameContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-bottom: 1px solid var(--grey-200);
`;

export const InputSourceTelematicItem = styled(Flex)`
  padding: 6px 0;
  border-bottom: 1px solid var(--grey-200);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
`;

export const InputSourceTelematicIdentifier = styled.span`
  background-color: ${({ color }) => color};
  width: 8px;
  height: 8px;
  border-radius: 100%;
`;
